import { Box, useRecipe, type BoxProps } from '@chakra-ui/react';

import type { JSX } from 'react';

import { codeRecipe } from './recipe';

export function Code(props: BoxProps): JSX.Element {
  const recipe = useRecipe({
    recipe: codeRecipe,
  });

  const styles = recipe();

  return <Box as='code' css={styles} {...props} />;
}
